import React from "react";
import PropTypes from "prop-types";
import { StyledCustomRadio } from "./style";

/**
 *
 * @param {*} props
 * @returns
 */
const CustomRadio = (props) => {
  const { name, value, title, subtitle, icon, onChange, selected } = props;

  const styleActive = {
    backgroundColor: selected ? "#EFFAFF99" : "#FFFFFF",
    marginTop: name === "sucursalOption" ? "10px" : "15px",
  };

  return (
    <StyledCustomRadio>
      <div className="container-custom-radio" style={styleActive}>
        <label className="label-radio">
          <input
            type="radio"
            name={name}
            value={value}
            checked={selected}
            onChange={onChange}
            className="input-radio"
          />
          <img
            src={icon}
            alt={title}
            style={{ width: "45px", marginRight: "16px" }}
          />
          <div>
            <div className="div-title">{title}</div>
            <div className="div-subtitle">{subtitle}</div>
          </div>
        </label>
      </div>
    </StyledCustomRadio>
  );
};

CustomRadio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

CustomRadio.defaultProps = {
  subtitle: "",
  selected: false,
};

export default CustomRadio;
